module.exports = __webpack_public_path__ + "img/arrow-diagonal.8504ac50.svg";